import React from 'react';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

function AntdDateRange() {
  return <RangePicker />;
}

export default AntdDateRange;
